export default function getKenticoImageSrc(src: string, width: number) {
    return `${src}?w=${width}`;
}
